<template>
  <main v-if='kirby.page.intendedTemplate == "event"'>
    <header>
      <tags>
        <li class='inverted' v-html='kirby.page.strings.category' />
        <li v-html='kirby.page.strings.location' />
      </tags>
      <close />
    </header>
    <h1 v-html='kirby.page.content.title.value' />
    <h4 class='time'>
      <time>{{formattedDate(kirby.page.strings.startdate, 'd.m.')}}</time>
      <span v-if='kirby.page.strings.startdate!=kirby.page.strings.enddate&&kirby.page.strings.startdate&&kirby.page.strings.enddate'>-</span>
      <time>{{formattedDate(kirby.page.strings.enddate, 'd.m.yy')}}</time>
    </h4>

    <gallery v-if='yaml(kirby.page.strings.files) && yaml(kirby.page.strings.files).length > 0' :filenames='yaml(kirby.page.strings.files)' :page='kirby.page' />

    <blocks v-if='kirby.page.strings.builder' :content='JSON.parse(kirby.page.strings.builder)' :page='kirby.page' />

    <article class='body'>
      <section class='english' v-html='kirby.page.content.english.kirbytext' />
      <section class='finnish' v-html='kirby.page.content.finnish.kirbytext' />
    </article>
  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc,
  mounted: function() {
    console.log('here!');
  },
  mounted: function(){
    this.$emit("addReasonToShowVeil");
  },
  destroyed: function(){
    this.$emit("removeReasonToShowVeil");
  },
}
</script>

<style scoped>

  h1 {
    margin-left: -0.05em;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }

  article {
    margin-top: 3rem;
    display: flex;
    flex-direction: var(--columndirection);
    gap: 2em;
  }

  article section {
    max-width: 30em;
  }

  h4.time {
    margin-bottom: 4rem;
  }

  #Close-Event {
    position: absolute;
    top: 2rem;
    right: 2rem;
  }
</style>

<style>

article a {
  color: var(darkgray);
  text-decoration: underline;
}

</style>
